import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { usePriceSettingsHook } from '../../Hooks/Maintenance/PriceSettings/priceSettingsHooks';

import { ModulePrice } from '../../Models/Maintenance/PriceSettings/PriceSettings';

import { FormModulePickerInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';
import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';

import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { PriceSettingsField } from '../../Utilities/Enums/ParametersEnum';

import CustomFormTitle from './CustomFormTitle';
import CustomCheckbox from './CustomCheckbox';

const StyledContainer = styled.div`
    // width: auto;
    width: -webkit-fill-available;
    margin: 5px 0px 0px 0px;
    overflow: unset !important;
`;

const ModulesContainer = styled(Card) <{ $darkMode?: boolean; $isError?: boolean; }>`
    background: transparent !important;
    border: 1px solid;
    border-radius: 4px !important;
    border-color: ${(props) => props.$isError ? '#d32f2f' : (props.$darkMode ? '#ffffff1f' : '#0000001f')} !important;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0px;
    box-shadow: none !important;
    overflow: unset !important;
    padding: 10px;

    .checkBoxContainer {
        .formControlContainer {
            .formCheckboxContainer {
                .checkboxSideLabel {
                    font-size: 0.825rem;
                    font-weight: 600;
                    color: ${(props) => props.$darkMode ? '#ced4da' : '#495057'} !important;
					word-break: break-all;
                }
            }
        }

    }
`;

const ModuleErrorMessage = styled(Typography) <{ $darkMode?: boolean; }>`
    color: #d32f2f !important;
    font-weight: 400 !important;
    font-size: 0.75rem !important;
`;

export default function FormModulePicker(fieldProps: FormModulePickerInterface) {
	let {
		errorMessages,
		title,
		hideLabel,
		name,
		fieldValue,
		required,
		handleOnChange,
		currencyCode = GlobalFunctionHelper.getCurrencyCode(),
	} = fieldProps;
	let darkMode = LocalStorageHelper?.isDarkMode() ?? false;

	let [modules, setmodules] = useState<ModulePrice[]>([]);

	const { getPriceSettings } = usePriceSettingsHook([CachingEnum.PRICE_SETTINGS], currencyCode ?? GlobalFunctionHelper.getCurrencyCode(), false);

	const initializeModules = async () => {
		let getCurrencyPriceSettings = await getPriceSettings({ currencyCode: currencyCode });

		setmodules(getCurrencyPriceSettings?.data?.[PriceSettingsField.MODULES] ?? []);
	}

	useEffect(() => {
		initializeModules();
	}, [currencyCode]);

	return <StyledContainer className="formModulePicker">
	    {!hideLabel && <CustomFormTitle title={title ?? "--"}
	        required={required}
	        hideLabel={hideLabel} />}

	    <ModulesContainer $darkMode={darkMode} $isError={errorMessages?.[name] ?? false}>
	        {modules?.map((mod: any, moduleIndex: number) => (<>
	            <CustomCheckbox name={name + moduleIndex}
	                title={mod?.[PriceSettingsField.MODULE_NAME] ?? "--"}
	                // hideLabel={true}
	                checkboxType={ButtonType.PRIMARY}
	                fieldValue={fieldValue?.find((item: any) => item == mod?.[PriceSettingsField.MODULE_PUBLIC_ID]) ? true : false}
	                handleOnChange={(a: any) => {
	                	let _isSelected = fieldValue?.find((item: any) => item == mod?.[PriceSettingsField.MODULE_PUBLIC_ID]) ? true : false;
	                	let _modules: string[] = fieldValue ?? [];

	                	if(_isSelected) {
	                        _modules = _modules.filter((item: any) => item != mod?.[PriceSettingsField.MODULE_PUBLIC_ID]);
	                    } else {
	                        _modules.push(mod?.[PriceSettingsField.MODULE_PUBLIC_ID]);
	                    }

	                	if(handleOnChange) {
	                		handleOnChange(_modules);
	                	}
	                }}
	                errorMessages={errorMessages} />
	        </>))}
	    </ModulesContainer>

	    {errorMessages?.[name] && <ModuleErrorMessage>{errorMessages?.[name] ?? ""}</ModuleErrorMessage>}
	</StyledContainer>
}